import * as React from "react";

function SvgGoogle({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#4B5563"
          fillRule="nonzero"
          d="M12.199 10.57V14h5.67c-.23 1.473-1.714 4.313-5.67 4.313-3.414 0-6.2-2.828-6.2-6.313 0-3.484 2.786-6.312 6.2-6.312 1.94 0 3.242.829 3.985 1.543l2.715-2.614C17.156 2.985 14.899 2 12.2 2c-5.527 0-10 4.473-10 10s4.473 10 10 10c5.77 0 9.601-4.058 9.601-9.77 0-.656-.07-1.156-.156-1.656L12.2 10.57h-.001z"
        />
      </g>
    </svg>
  );
}

export default SvgGoogle;
